const formatKilometers = (distance: number | undefined): string => {
  if (distance === undefined) {
    return "";
  }
  if (distance < 1) {
    return `${Math.round(distance * 1000)} m`;
  }
  return `${Math.round(distance)} km`;
};

export { formatKilometers };
